import { takeEvery, put } from 'redux-saga/effects';
import * as types from './actionTypes.mobileSpecificBehaviour';
import * as errorSaga from '../errors/saga.errors';
import device from '../../services/mini/device';
import isSessionStorageAvailable from '../../services/mini/isSessionStorageAvailable';
import { IBaseAction } from '../base';

export function* watch() {
    yield takeEvery<IBaseAction>(types.SHOW_MOBILE_WARNING_REQ, showMobileWarning);
    yield takeEvery<IBaseAction>(types.HIDE_MOBILE_WARNING_OK, hideMobileWarning);
}


export function* showMobileWarning() {
    try {
        if (device.isMobile()) {
            var storageAvailable = isSessionStorageAvailable();
            var warningWasShown = storageAvailable ?
                sessionStorage.getItem('mobile_warning_was_shown') :
                window.mobileWarningWasShown;

            if (!warningWasShown) {
                yield put({ type: types.SHOW_MOBILE_WARNING_OK });
            }
        }
    } catch (error) {
        yield errorSaga.putError(error);
    }
}
export function* hideMobileWarning() {
    try {
        var storageAvailable = isSessionStorageAvailable();
        if (storageAvailable) {
            sessionStorage.setItem('mobile_warning_was_shown', 'true');
        } else {
            window.mobileWarningWasShown = true;
        }
    } catch (error) {
        yield errorSaga.putError(error);
    }
}